import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const SEO = ({
  titleKey,
  descriptionKey,
  path = '',
  image = 'https://fleurdeselrestaurant.lu/img/inicio/3.jpg'
}) => {
  const { t, i18n } = useTranslation();

  const title = titleKey ? `${t(titleKey)} | Fleur de Sel` : 'Fleur de Sel - Restaurant Luxembourg';
  const description = descriptionKey ? t(descriptionKey) : t('seo.defaultDescription');
  const url = `https://fleurdeselrestaurant.lu${path}`;
  const currentLang = i18n.language;

  // Map language codes to hreflang format
  const langMap = {
    'pt': 'pt-PT',
    'en': 'en-GB',
    'fr': 'fr-LU'
  };

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <html lang={langMap[currentLang] || 'fr-LU'} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="author" content="Fleur de Sel" />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="Fleur de Sel Luxembourg" />
      <meta property="og:locale" content={langMap[currentLang] || 'fr_LU'} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Alternate Languages (hreflang) */}
      <link rel="alternate" hrefLang="pt-PT" href={`https://fleurdeselrestaurant.lu${path}`} />
      <link rel="alternate" hrefLang="en-GB" href={`https://fleurdeselrestaurant.lu${path}`} />
      <link rel="alternate" hrefLang="fr-LU" href={`https://fleurdeselrestaurant.lu${path}`} />
      <link rel="alternate" hrefLang="x-default" href={`https://fleurdeselrestaurant.lu${path}`} />

      {/* Geo Tags for Local SEO - Luxembourg */}
      <meta name="geo.region" content="LU" />
      <meta name="geo.placename" content="Luxembourg" />
      <meta name="geo.position" content="49.60068290934538;6.131038237594128" />
      <meta name="ICBM" content="49.60068290934538, 6.131038237594128" />
    </Helmet>
  );
};

export default SEO;
